// ======================================================================
// File Name       : ConfigFileAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as configFileRequest from './httpRequests/configFile';
import * as actionCreators from './actionCreators/configFile';

export function getDownloadConfigFileResult(param) {
  return async (dispatch) => {
    let recordNum = 0;
    let userfrontDownloadResultList = [];
    const result = await configFileRequest.postDownloadConfigFileResult(param);
    if (result && result.userfrontDownloadResultList) {
      recordNum = result.recordNum;
      userfrontDownloadResultList = result.userfrontDownloadResultList;
    }
    return dispatch(actionCreators.getDownloadConfigFileResult(recordNum, userfrontDownloadResultList));
  };
}

export function resetDataDownloadConfigFile() {
  return (dispatch) => {
    dispatch(actionCreators.resetDataDownloadConfigFile());
  };
}

export function downloadConfigFile() {
  return async (dispatch) => {
    await configFileRequest.postDownloadConfigFile();
    return {};
  };
}

export function getUploadConfigFileResult(param) {
  return async (dispatch) => {
    let recordNum = 0;
    let userfrontUploadResultList = [];
    const result = await configFileRequest.postUploadConfigFileResult(param);
    if (result && result.userfrontUploadResultList) {
      recordNum = result.recordNum;
      userfrontUploadResultList = result.userfrontUploadResultList;
    }
    return dispatch(actionCreators.getUploadConfigFileResult(recordNum, userfrontUploadResultList));
  };
}

export function resetDataUploadConfigFile() {
  return (dispatch) => {
    dispatch(actionCreators.resetDataUploadConfigFile());
  };
}

export function uploadConfigFile(uploadFile) {
  return async (dispatch) => {
    const param = {
      uploadFile,
    };
    await configFileRequest.postUploadConfigFile(param);
    return {};
  };
}
